import axios from 'axios';
import { getActiveContentDateRange } from './activeContentDateRange';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.iskenderun.bel.tr/api';

const normalizeStartDate = (date) => {
  if (!date) {
    return null;
  }

  const normalizedDate = new Date(date);
  normalizedDate.setHours(0, 0, 0, 0);
  return normalizedDate.toISOString();
};

const normalizeEndDate = (date) => {
  if (!date) {
    return null;
  }

  const normalizedDate = new Date(date);
  normalizedDate.setHours(23, 59, 59, 999);
  return normalizedDate.toISOString();
};

export const getParlamentDecisions = async (pageNum, pageSize, searchTerm = "", startDate = null, endDate = null) => {
  try {
    const { startDate: defaultStartDate, endDate: defaultEndDate } = getActiveContentDateRange();

    const response = await axios.post(`${API_URL}/ParlamentDecisions/GetParlamentDecisionses`, {
      pageNum,
      pageSize,
      searchTerm,
      sortBy: "",
      startDate: normalizeStartDate(startDate) || defaultStartDate,
      endDate: normalizeEndDate(endDate) || defaultEndDate
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching parlament decisions:', error);
    throw error;
  }
};

export const getParlamentMembers = async (pageNum = 1, pageSize = 50, searchTerm = "", startDate = null, endDate = null) => {
  try {
    const response = await axios.post(`${API_URL}/ParlamentMembers/GetParlamentMembers`, {
      pageNum,
      pageSize,
      searchTerm,
      sortBy: "",
      startDate: startDate ? startDate.toISOString() : "2007-03-25T11:47:12.648Z",
      endDate: endDate ? endDate.toISOString() : "2030-04-13T00:37:05.648Z"
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching parlament members:', error);
    throw error;
  }
};

export const getParlamentDecisionById = async (guid) => {
  try {
    const response = await axios.post(`${API_URL}/ParlamentDecisions/GetParlamentDecisionsById`, {
      guid
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching parlament decision detail:', error);
    console.error('Error response data:', error.response?.data);
    console.error('Error status:', error.response?.status);
    throw error;
  }
};
